"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientSource = exports.Patient = exports.Record = void 0;
var DT = __importStar(require("./datatypes/datatypes"));
var Record = /** @class */ (function () {
    function Record(json) {
        this.json = json;
        this.id = this.json.id;
    }
    Record.prototype._is = function (typeSpecifier) {
        return this._typeHierarchy().some(function (t) { return t.type === typeSpecifier.type && t.name == typeSpecifier.name; });
    };
    Record.prototype._typeHierarchy = function () {
        return [
            {
                name: "{https://github.com/cqframework/cql-execution/simple}".concat(this.json.recordType),
                type: 'NamedTypeSpecifier'
            },
            {
                name: '{https://github.com/cqframework/cql-execution/simple}Record',
                type: 'NamedTypeSpecifier'
            },
            { name: '{urn:hl7-org:elm-types:r1}Any', type: 'NamedTypeSpecifier' }
        ];
    };
    Record.prototype._recursiveGet = function (field) {
        if (field != null && field.indexOf('.') >= 0) {
            var _a = field.split('.', 2), root = _a[0], rest = _a[1];
            return new Record(this._recursiveGet(root))._recursiveGet(rest);
        }
        return this.json[field];
    };
    Record.prototype.get = function (field) {
        // the model should return the correct type for the field. For this simple model example,
        // we just cheat and use the shape of the value to determine it. Real implementations should
        // have a more sophisticated approach
        var value = this._recursiveGet(field);
        if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}(T[\d\-.]+)?/.test(value)) {
            return this.getDate(field);
        }
        if (value != null && typeof value === 'object' && value.code != null && value.system != null) {
            return this.getCode(field);
        }
        if (value != null && typeof value === 'object' && (value.low != null || value.high != null)) {
            return this.getInterval(field);
        }
        return value;
    };
    Record.prototype.getId = function () {
        return this.id;
    };
    Record.prototype.getDate = function (field) {
        var val = this._recursiveGet(field);
        if (val != null) {
            return DT.DateTime.parse(val);
        }
        else {
            return null;
        }
    };
    Record.prototype.getInterval = function (field) {
        var val = this._recursiveGet(field);
        if (val != null && typeof val === 'object') {
            var low = val.low != null ? DT.DateTime.parse(val.low) : null;
            var high = val.high != null ? DT.DateTime.parse(val.high) : null;
            return new DT.Interval(low, high);
        }
    };
    Record.prototype.getDateOrInterval = function (field) {
        var val = this._recursiveGet(field);
        if (val != null && typeof val === 'object') {
            return this.getInterval(field);
        }
        else {
            return this.getDate(field);
        }
    };
    Record.prototype.getCode = function (field) {
        var val = this._recursiveGet(field);
        if (val != null && typeof val === 'object') {
            return new DT.Code(val.code, val.system, val.version);
        }
    };
    return Record;
}());
exports.Record = Record;
var Patient = /** @class */ (function (_super) {
    __extends(Patient, _super);
    function Patient(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.gender = json.gender;
        _this.birthDate = json.birthDate != null ? DT.DateTime.parse(json.birthDate) : undefined;
        _this.records = {};
        (json.records || []).forEach(function (r) {
            if (_this.records[r.recordType] == null) {
                _this.records[r.recordType] = [];
            }
            _this.records[r.recordType].push(new Record(r));
        });
        return _this;
    }
    Patient.prototype.findRecords = function (profile) {
        if (profile == null) {
            return [];
        }
        var match = profile.match(/(\{https:\/\/github\.com\/cqframework\/cql-execution\/simple\})?(.*)/);
        if (match == null)
            return [];
        var recordType = match[2];
        if (recordType === 'Patient') {
            return [this];
        }
        else {
            return this.records[recordType] || [];
        }
    };
    return Patient;
}(Record));
exports.Patient = Patient;
var PatientSource = /** @class */ (function () {
    function PatientSource(patients) {
        this.patients = patients;
        this.nextPatient();
    }
    PatientSource.prototype.currentPatient = function () {
        return this.current;
    };
    PatientSource.prototype.nextPatient = function () {
        var currentJSON = this.patients.shift();
        this.current = currentJSON ? new Patient(currentJSON) : undefined;
        return this.current;
    };
    return PatientSource;
}());
exports.PatientSource = PatientSource;
//# sourceMappingURL=cql-patient.js.map